import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_PATH,
});

const workspace = axios.create({
  baseURL: process.env.REACT_APP_WORKSPACE_API_PATH,
});

const pdfWorkspace = axios.create({
  baseURL: process.env.REACT_APP_PDF_WORKSPACE_API_PATH,
});

const apiNx = axios.create({
  baseURL: process.env.REACT_APP_API_NX_PATH,
});

const apiTranslate = axios.create({
  baseURL: process.env.REACT_APP_GOOGLE_TRANSLATE_PATH,
});

export const SNCR_ANVISA_BASE_URL =
  process.env.REACT_APP_SNCR_API_BASE_URL || 'https://sncr-api.hmg.apps.anvisa.gov.br/api/v1';

export const SNCR_CALLBACK_ORIGIN = process.env.REACT_APP_SNCR_CALLBACK_ORIGIN;

// DÍVIDA TÉCNICA: esta função (e setPrescriptionIdHeader abaixo) registra um novo
// interceptor de request a cada chamada, sem fazer eject dos anteriores — eles se acumulam.
// Como request interceptors do axios rodam em ordem reversa (LIFO) e todos escrevem o mesmo
// header, o PRIMEIRO token registrado prevalece. Hoje é inofensivo porque dentro de um
// carregamento o valor é sempre o mesmo, mas se o token/prescriptionId mudar sem reload
// (refresh, troca de contexto/prescrição) as requests passarão a usar o valor ANTIGO → 401
// ou x-prescription-id errado. Correção: registrar 1 interceptor por instância no boot, lendo
// de uma variável mutável que esta função apenas atualiza.
const setAuthorizationHeader = (authorizationToken: string) => {
  const authorizationType = authorizationToken.startsWith('jwt-mevo-') ? 'Bearer' : 'Basic';
  const token = `${authorizationType} ${authorizationToken.replace(/jwt-mevo-/gi, '')}`;

  api.interceptors.request.use((config) => {
    config.headers.Authorization = `${token}`;
    return config;
  });

  workspace.interceptors.request.use((config) => {
    config.headers.Authorization = `${token}`;
    return config;
  });

  pdfWorkspace.interceptors.request.use((config) => {
    config.headers.Authorization = `${token}`;
    return config;
  });
};

export const setPrescriptionIdHeader = (prescriptionId: number) => {
  if (!!(window as any).Cypress) return;

  api.interceptors.request.use((config) => {
    config.headers['x-prescription-id'] = `${prescriptionId}`;
    return config;
  });

  workspace.interceptors.request.use((config) => {
    config.headers['x-prescription-id'] = `${prescriptionId}`;
    return config;
  });

  pdfWorkspace.interceptors.request.use((config) => {
    config.headers['x-prescription-id'] = `${prescriptionId}`;
    return config;
  });
};

export const isRequestCanceled = (error: unknown): boolean => axios.isCancel(error);

export { setAuthorizationHeader, api, apiNx, apiTranslate, workspace, pdfWorkspace };
